import { render, staticRenderFns } from "./ProjectItem.vue?vue&type=template&id=571fe91f&"
import script from "./ProjectItem.vue?vue&type=script&lang=ts&"
export * from "./ProjectItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports